/**
 * Build a full URL for a server-stored file (e.g. an uploaded proof image).
 *
 * Stored proof paths look like "/uploads/delivery_proofs/<file>.png" and are
 * served from the backend ORIGIN, not under the "/api/v1" API base. So we take
 * REACT_APP_API_URL, strip a trailing "/api/v1", and prepend the result.
 *
 * @param path Stored file path (may be absolute, relative, null, or undefined)
 * @returns Absolute URL, or null when no path is given
 */
export const buildFileUrl = (path?: string | null): string | null => {
  if (!path) {
    return null;
  }

  // Already an absolute URL — use as-is
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const apiBase = process.env.REACT_APP_API_URL || '';
  const origin = apiBase.replace(/\/api\/v1\/?$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${origin}${normalizedPath}`;
};

export default buildFileUrl;
